export const Endpoints = {
    //agencies
    GET_TIMELINE_AGENCY_HISTORICAL: "agencies/{agency}/historical",
    GET_TIMELINE_AGENCY_FUTURE: "agencies/{agency}/future",
    GET_TIMELINE_AGENCY_PROPOSALS_PENDING_RESPONSE: "agencies/{agency}/proposals-pending-response",
    GET_TIMELINE_AGENCY_CAMPAIGNS_FUTURE: "agencies/{agency}/campaigns-future",
    GET_TIMELINE_METRIC_AGENCY: "agencies/{agency}/metric",
    GET_TIMELINE_INFO_AGENCY: "agencies/{agency}/info",
    GET_AGENCY: "agencies/{agency}",
    PUT_AGENCY: "agencies/{agency}",
    PUT_AGENCY_ENABLE: "agencies/{agency}/enable",
    DELETE_AGENCY: "agencies/{agency}",
    GET_AGENCIES: "agencies",
    POST_AGENCIES: "agencies",

    //workers
    GET_TIMELINE_WORKER_HISTORICAL: "workers/{worker}/historical",
    GET_TIMELINE_WORKER_FUTURE: "workers/{worker}/future",
    GET_TIMELINE_WORKER_PROPOSALS_PENDING_RESPONSE: "workers/{worker}/proposals-pending-response",
    GET_TIMELINE_WORKER_CAMPAIGNS_FUTURE: "workers/{worker}/campaigns-future",
    GET_TIMELINE_METRIC_WORKER: "workers/{worker}/metric",
    GET_TIMELINE_INFO_WORKER: "workers/{worker}/info",
    GET_WORKERS: "workers",

    //providers
    GET_TIMELINE_PROVIDER_HISTORICAL: "providers/{provider}/historical",
    GET_TIMELINE_PROVIDER_FUTURE: "providers/{provider}/future",
    GET_TIMELINE_PROVIDER_PROPOSALS_PENDING_RESPONSE: "providers/{provider}/proposals-pending-response",
    GET_TIMELINE_PROVIDER_CAMPAIGNS_FUTURE: "providers/{provider}/campaigns-future",
    GET_TIMELINE_METRIC_PROVIDER: "providers/{provider}/metric",
    GET_TIMELINE_INFO_PROVIDER: "providers/{provider}/info",
    GET_PROVIDERS: "providers",
    POST_PROVIDERS: "providers",
    PUT_PROVIDER: "providers/{provider}",
    PUT_PROVIDER_ENABLE: "providers/{provider}/enable",
    GET_PROVIDER: "providers/{provider}",
    DELETE_PROVIDER: "providers/{provider}",

    //contacts
    GET_TIMELINE_CONTACT_HISTORICAL: "contacts/{contact}/historical",
    GET_TIMELINE_CONTACT_FUTURE: "contacts/{contact}/future",
    GET_TIMELINE_CONTACT_PROPOSALS_PENDING_RESPONSE: "contacts/{contact}/proposals-pending-response",
    GET_TIMELINE_CONTACT_CAMPAIGNS_FUTURE: "contacts/{contact}/campaigns-future",
    GET_TIMELINE_METRIC_CONTACT: "contacts/{contact}/metric",
    GET_TIMELINE_INFO_CONTACT: "contacts/{contact}/info",
    GET_CONTACTS: "contacts/select",
    GET_CONTACTS_AGENCIES: "contacts/{contact_id}/agencies",
    GET_CONTACTS_ACCOUNTS: "contacts/{contact_id}/accounts",
    GET_CONTACTS_PROVIDERS: "contacts/{contact_id}/providers",
    GET_CONTACT_ORIGIN: "contact-origins",
    GET_CONTACT_CATEGORIES: "contact-categories",
    GET_CONTACTS_FILTER: "contacts/filter",
    POST_CONTACT: "contacts",
    PUT_CONTACT: "contacts/{contact_id}",
    DELETE_CONTACT: "contacts/{contact_id}",
    GET_CONTACTS_LAST_UPDATED: "contacts/last-updated",
    GET_LAST_CONTACTS_UPDATED: "contacts/last-updated",

    //actions
    GET_METRICS_KPIS: "metrics/kpis",
    GET_METRICS_CHARTS_ACTION_TYPES: "actions/charts/action-types",
    GET_METRICS_CHARTS_ACTIONS_BY_USER: "workers/graph-actions",
    GET_METRICS_AMOUNTS: "proposals/metrics/total-amounts",
    GET_METRICS_CHARTS_ACTIONS_EVOLUTION: "actions/charts/monthly-history",
    GET_METRICT_CHART_ACTION_BY_ACCOUNT: "accounts/charts/actions",
    GET_ACTIONS: "actions",
    GET_ACTIONS_FUTURE: "actions/future",
    GET_ACTIONS_PENDING_CONFIRMATION: "actions/pending-confirmation",
    PUT_ACTIONS_CONFIRMATION: "actions/{action}/confirmation",
    POST_ACTION: "actions",
    DELETE_ACTION: "actions/{action_id}",
    GET_ACTION: "actions/{action_id}",
    PUT_ACTION: "actions/{action_id}",

    //accounts
    GET_TIMELINE_ACCOUNT_HISTORICAL: "accounts/{account}/historical",
    GET_TIMELINE_ACCOUNT_FUTURE: "accounts/{account}/future",
    GET_TIMELINE_ACCOUNT_PROPOSALS_PENDING_RESPONSE: "accounts/{account}/proposals-pending-response",
    GET_TIMELINE_ACCOUNT_CAMPAIGNS_FUTURE: "accounts/{account}/campaigns-future",
    GET_TIMELINE_METRIC_ACCOUNT: "accounts/{account}/metric",
    GET_TIMELINE_INFO_ACCOUNT: "accounts/{account}/info",
    GET_ACCOUNTS: "accounts",
    POST_ACCOUNTS: "accounts",
    PUT_ACCOUNT: "accounts/{account}",
    PUT_ACCOUNT_ENABLE: "accounts/{account}/enable",
    GET_ACCOUNT: "accounts/{account}",
    GET_ACCOUNT_FULL: "accounts/{account}/full",
    DELETE_ACCOUNT: "accounts/{account}",
    GET_ACCOUNTS_RECENTLY_USED: "accounts/recently-used",

    //proposals
    GET_PROPOSAL: "proposals/{proposal}",
    GET_PROPOSAL_ELEMENTS_PROPOSALS: "proposals/{proposal}/element-proposals",
    POST_ELEMENT_PROPOSALS: "proposals/{proposal}/element-proposals",
    DELETE_ELEMENT_PROPOSALS: "element-proposals",
    GET_PROPOSAL_MAP_ELEMENT_PROPOSALS: "proposals/{proposal}/map/element-proposals",
    DELETE_PROPOSAL_MAP_ELEMENT_PROPOSAL: "proposals/{proposal}/map/elements/{element}",
    GET_PROPOSAL_ELEMENTS_LOCATIONS: "elements/locations",
    POST_ELEMENT_PROPOSALS_ELEMENT_PROPOSAL_ELEMENT_ELEMENT: "element-proposals/{element_proposal}/element/{element}",
    PUT_PROPOSAL_UPDATE_STATUS: "proposals/{proposal}/status",
    PUT_PROPOSAL_TO_CAMPAIGN: "proposals/{proposal}/convert-campaign",
    PUT_PROPOSAL_FORCE_TO_CAMPAIGN: "proposals/{proposal}/force-convert-campaign",
    PUT_PROPOSAL_UNLOCK: "proposals/{proposal}/unlock",
    PUT_UPDATE_DATES_ELEMENT_PROPOSALS: "supplier-alias-proposal/dates",
    GET_PROPOSAL_MESSAGES: "proposals/{proposal}/messages",
    GET_ELEMENT_PROPOSALS_SUPPLIER_ALIAS_PROPOSAL_ELEMENTS: "element-proposals/{supplier_alias_proposal}/elements",
    PUT_PROPOSAL: "proposals/{proposal}",
    GET_ELEMENT_OCCUPATION_GENERIC: "elements/occupation/generic",
    POST_ELEMENT_PROPOSAL_SUPPLIER_ALIAS_PROPOSAL: "supplier-alias-proposal/{supplier_alias_proposal}/elements",
    DELETE_ELEMENT_PROPOSAL_SUPPLIER_ALIAS_PROPOSAL: "supplier-alias-proposal/{supplier_alias_proposal}/elements",
    POST_PROPOSAL_STRATEGY: "proposals/{proposal}/strategy",
    DELETE_PROPOSAL_STRATEGY: "proposals/strategy/{strategy}",
    GET_PROPOSAL_STRATEGY_SUBCATEGORIES: "proposals/{proposal}/strategy-subcategories",
    GET_PROPOSAL_STRATEGY_ELEMENTS_PROPOSAL: "proposals/{proposal}/strategy-element-proposals",
    POST_PROPOSAL_STRATEGY_IMG: "proposals/{proposal}/strategy/file",

    //checking
    GET_PROPOSAL_CHECKING: "proposals/checking/{proposal}",
    GET_PROPOSAL_CHECKING_SUBCATEGORIES: "proposals/{proposal}/subcategories",
    GET_PROPOSAL_CHECKING_ELEMENT_LOCATIONS: "proposals/{proposal}/element-proposals/location",
    GET_PROPOSAL_CHECKING_ELEMENTS: "proposals/checking/{proposal}/element-proposals",
    PUT_PROPOSAL_CHECKING_CHANGE_REQUEST: "proposals/{proposal}/changeRequest",
    PUT_PROPOSAL_CHECKING_DECLINE: "proposals/{proposal}/decline",
    PUT_PROPOSAL_CHECKING_ACCEPT: "proposals/{proposal}/accept",

    //campaigns
    GET_CAMPAIGNS: "campaigns/{campaing}",
    GET_CAMPAIGNS_SELECT: "campaigns/select",
    PUT_CAMPAIGNS_COLOR_TEST: "campaigns/{campaing}/color-test",
    PUT_CAMPAIGNS_CONFIRM: "campaigns/{campaing}/confirm",
    GET_ELEMENTS_CAMPAIGNS: "campaings/{campaing}/element-campaings",
    DELETE_ELEMENTS_CAMPAIGN: "campaings/element-campaings",
    POST_ELEMENT_CAMPAIGNS: "campaings/{campaign}/element-proposals",
    GET_CAMPAIGN_REASONS: "campaigns/{campaign}/reasons",
    GET_CAMPAIGN_REASONS_FILTERED: "campaigns/{campaign}/reasons-filtered",
    GET_CAMPAIGN_SUPPLIER_ALIAS_REASON: "campaings/{campaign}/supplier-alias-campaings/reasons",
    GET_ELEMENTS_CAMPAIGNS_MAP: "campaings/{campaing}/map/element-campaings",

    //cities
    GET_CITIES: "countries/{country_id}/cities",
    GET_ESTATES_CITIES: "states/cities",

    //elements
    GET_ELEMENTS_ADDRESSES: "elements/addresses",
    GET_ELEMENTS_OCCUPATION_CAMPAIGN_GENERIC: "elements/occupation/campaign/generic",
    GET_ELEMENTS_CAMPAIGNS_SUPPLIER_ALIAS_PROPOSAL: "element-proposals/{supplier_alias_proposal}/elements",
    POST_ELEMENT_CAMPAIGNS_SUPPLIER_ALIAS_PROPOSAL_ELEMENT:
        "element-campaigns/{supplier_alias_proposal}/element/{element}",
    DELETE_ELEMENT_CAMPAIGNS_SUPPLIER_ALIAS_PROPOSAL_ELEMENT:
        "element-campaigns/{supplier_alias_proposal}/element/{proposal_element}",
    PUT_ELEMENT_PROPOSALS_SUPPLIER_ALIAS_PROPOSAL: "element-proposals/{supplier_alias_proposal}",

    //others
    GET_CONTACTS_TYPE: "contact-types/select",
    GET_COUNTRIES: "v2/countries",
    GET_POSITIONS: "contact-positions",
    GET_MARITAL_STATUSES: "marital-statuses",
    GET_POTENTIALITIES: "potentialities",
    GET_ACTION_TYPES: "action-types",
    GET_CURRENCY: "currencies",
    GET_PROVIDER_TYPES: "provider-types",
    GET_INDUSTRIES: "industries",
    GET_SUBINDUSTRIES: "subindustries/{industry}",
    GET_COMPANIES_TYPES: "companies/types",
    GET_COMPANY_TYPES: "company-types",
    POST_SUPPORT: "support",
    GET_COMPANY_MIXED: "company-mixed",
    GET_SUPPLIER_ALIASES: "supplier-aliases/group",
    GET_PRINTABLE_FORMATS: "printable-formats",
    GET_TECHNOLOGIES: "technologies",
    GET_INTERVAL_START_TIME: "interval-start-date",
    GET_ELEMENT_CATEGORIES: "categories",
    GET_ELEMENT_SUBCATEGORIES: "subcategories",
    GET_ELEMENT_TYPES: "subcategories/supplier-aliases",
    GET_MAX_OTS: "ots",

    //osdepym
    GET_SUBSIDIARY: "subsidiary/{subsidiary}",
    GET_LIST_SUBSIDIARY: "subsidiary",
    GET_LIST_SUBSIDIARY_SELECT: "subsidiary/select",
    POST_SUBSIDIARY: "subsidiary",
    PUT_SUBSIDIARY: "subsidiary/{subsidiary}",
    DELETE_SUBSIDIARY: "subsidiary/{subsidiary}",
    GET_AGENT: "agent/{agent}",
    GET_LIST_AGENT: "agent",
    POST_AGENT: "agent",
    PUT_AGENT: "agent/{agent}",
    DELETE_AGENT: "agent/{agent}",
    GET_AGENT_TYPES: "agent/types",
    GET_OSDEPYM_COUNTRIES: "countries",
    GET_OSDEPYM_PROVINCES: "countries/{country}/provinces",
    GET_OSDEPYM_CITIES: "provinces/{province}/cities",
    POST_OSDEPYM_PREPROSPECT: "preprospect",
    GET_OSDEPYM_PROSPECT: "contacts",
    GET_OSDEPYM_CONTACTS_LAST_ASSIGN: "contacts/{contact}/last-assign",
    PUT_OSDEPYM_PREPROSPECT: "preprospect/{preprospect}",
    POST_OSDEPYM_PROSPECT: "contacts",
    POST_OSDEPYM_PROSPECT_ASSIGN: "contacts/{prospect}/assign",
    PUT_OSDEPYM_PROSPECT: "contacts/{prospect}",
    PUT_OSDEPYM_PROSPECT_DISCARD: "contacts/{prospect}/discard",
    GET_OSDEPYM_PROSPECT_PROSPECT: "contacts/{prospect}",
    GET_OSDEPYM_PROSPECT_COVERAGES: "contacts/coverages",
    GET_OSDEPYM_PROSPECT_ORIGINS: "contacts/origins",
    GET_OSDEPYM_PROSPECT_SUB_ORIGINS: "contacts/origins/{origins}",
    GET_OSDEPYM_PROSPECT_REASONS: "contacts/reasons",
    GET_OSDEPYM_CONTACTS_CATEGORIES: "contacts/categories",
    GET_OSDEPYM_CONTACTS_STATUSES: "contacts/statuses",
    GET_OSDEPYM_PLANS: "plans",
    GET_OSDEPYM_FILES_TYPES: "files/types",
    GET_OSDEPYM_CONTACTS_FILES: "contacts/{contact}/files",
    DELETE_OSDEPYM_CONTACTS_FILE: "contacts/{contact}/file/{file}",
    POST_OSDEPYM_CONTACTS_FILE: "contacts/{contact}/file",
    GET_OSDEPYM_CONTACTS_SEARCH: "contacts/search", // params "email", "cuil" o "phone"
    GET_OSDEPYM_PREPROSPECT_SEARCH: "preprospect/search", // params "email", "cuil" o "phone"
    GET_FORGOT_PASSWORD: "forgot-password",
    POST_FORGOT_PASSWORD: "reset-password",
    GET_OSDEPYM_ACTIONS: "actions",
    GET_OSDEPYM_PAYMENTS_TYPES: "payments/types",
    POST_OSDEPYM_ACTIONS: "actions",
    POST_OSDEPYM_ACTION_CONFIRM: "/actions/{action}/confirm",
    DELETE_OSDEPYM_ACTIONS: "/actions/{action}",
    GET_OSDEPYM_ACTIONS_ACTION: "actions/{action}",
    PUT_OSDEPYM_ACTIONS: "actions/{action}",
    DELETE_OSDEPYM_ACTIONS_FILE: "actions/{action}/file/{file}",
    GET_OSDEPYM_ACTIONS_TYPES: "actions/types",
    GET_CONTACTS_HISTORICAL: "contacts/{contact}/historical", //params: company_id, past: 1(para gestiones pasadas), future: 1(para gestiones futuras), pending: 1(para gestiones pendientes) filtros: text, date,	actionType -- para pasar mas de un tipo, separar por coma (1,2,..)
    GET_AGENTS_HISTORICAL: "agent/{agent}/historical",
    GET_TOKEN_DATA: "tokens/{token}",
    GET_OSDEPYM_REPORTS_CONTACTS_STATS: "reports/contacts-stats",
    GET_OSDEPYM_REPORTS_CONTACTS_MONTHLY: "reports/contacts-monthly",
    GET_OSDEPYM_REPORTS_CONTACTS_SUBSIDIARIES: "reports/contacts-subsidiaries",
    GET_OSDEPYM_REPORTS_CONTACTS_PLANS: "reports/contacts-plans",
    GET_OSDEPYM_KINSHIPS_TYPES: "kinships/types",
    POST_OSDEPYM_KINSHIPS: "kinships",
    GET_OSDEPYM_CONTACTS_KINSHIPS: "contacts/{contact}/kinships",
    DELETE_OSDEPYM_KINSHIPS_KINSHIP: "kinships/{kinship}",
    PUT_OSDEPYM_KINSHIPS_KINSHIP: "kinships/{kinship}",
    GET_OSDEPYM_KINSHIPS_KINSHIP: "kinships/{kinship}",
    POST_OSDEPYM_QUOTATION: "osdepym/quotation",
    PUT_OSDEPYM_QUOTATIONS_QUOTATION: "quotations/{quotation}",
    GET_OSDEPYM_DISPLAY_FORM: "display-form",
    PUT_OSDEPYM_DISPLAY_FORM: "display-form",
    GET_OSDEPYM_VALID_PHONE: "valid-phone", //param "phone"
    GET_OSDEPYM_VALID_CUIL: "valid-cuil", // param "cuil"
    GET_OSDEPYM_METRICS_ACTION_TYPES: "metrics/actions-types",
    GET_OSDEPYM_METRICS_TOP_AGENTS: "metrics/top-agents",
    GET_OSDEPYM_METRICS_TOP_PLANS: "metrics/top-plans",
    GET_OSDEPYM_METRICS_CONTACTS_STATUSES: "metrics/contacts-statuses",

    //tickets
    GET_TICKETS: "tickets", //company_id, status (2 pendiente, 3 cancelados, 7 cerrados)
    POST_TICKET: "tickets", //menu_id: id, title: text, description: text, files: array
    GET_SECTIONS: "menu",
    DELETE_TICKET: "/tickets/{id}/cancel",
    GET_MENUES: "menues",
    POST_SAVE_TICKET: "save-ticket",

    //Newsletters
    GET_SENDERS: "newsletters/senders",
    GET_NEWSLETTER_TEMPLATE: "newsletters/template",
    POST_NEWSLETTER_TEMPLATE: "newsletters/template", //title: string, body: html/string
    GET_NEWSLETTER_TEMPLATE_ITEM: "newsletters/template/{id}",
    PUT_NEWSLETTER_TEMPLATE_ITEM: "newsletters/template/{id}", //title: string, body: html/string
    DELETE_NEWSLETTER_TEMPLATE_ITEM: "newsletters/template/{id}",
    GET_NEWSLETTER: "newsletters", //title: string, opcional. sendAt: date, opcional. draft: 0/1, opcional. sended: 0/1, opcional. scheduled: 0/1, opcional
    POST_NEWSLETTER: "newsletters", //sender_id: integer, title: string, body: string, status_id: 11 (borrador), 12 (programado), 13 (enviar ahora). audience: string, opcional. template_id: integer, opcional
    GET_NEWSLETTER_ITEM: "newsletters/{id}",
    PUT_NEWSLETTER_ITEM: "newsletters/{id}", //sender_id: integer, title: string, body: string. status_id: 11 (borrado), 12 (programado), 13 (enviar ahora), 14 pausado. audience: string, opcional, template_id: integer, opcional
    DELETE_NEWSLETTER_ITEM: "newsletters/{id}",
    PUT_NEWSLETTER_STATUS: "newsletters/{id}/status", //status_id: 11 (borrador), 12 (programado), 13 (enviar ahora), 14 (pausado)
    POST_NEWSLETTER_TEST: "newsletters/{id}/test", //emails: string

    //reasons
    POST_REASONS: "reasons",
    GET_LIST_REASONS: "reasons",
    PUT_REASONS: "reasons/{reason}",
    DELETE_REASONS: "reasons",
    POST_REASON_ELEMENT_CAMPAIGN: "reasons/{reason}/element-proposal-reasons",
    DELETE_REASON_ELEMENT_CAMPAIGN: "element-proposal-reasons/{element_proposal_reason}",
    POST_DUPLICATE_REASON_ELEMENT_CAMPAIGN: "element-proposal-reasons/{element_proposal_reason}/duplicate",
    PUT_REASON_ELEMENT_CAMPAIGN: "element-proposal-reasons/{element_proposal_reason}",

    //weekdays
    GET_WEEKDAYS: "weekdays",

    // arts management
    GET_ARTS_STATUS_FLOWS: "status-flows",
    GET_ARTS_STATUS_FLOWS_SELECT: "status-flows/select",
    GET_ARTS_CARDS: "cards",
    GET_ARTS_CARD: "cards/{card}",
    PUT_ARTS_CARD: "cards/{card}",
    GET_ARTS_CARD_EDIT: "cards/{card}/edit",
    POST_ARTS_SAVE_FILE: "cards/{card}/fields/{field}/media",
    GET_CARDS_DOWNLOAD_FILE: "cards/{card}/download-file",
    POST_ARTS_FILE_LOW: "cards/{card}/fields/{field}/media",
    DELETE_ARTS_FILE_LOW: "cards/{card}/fields/{field}/media",
    GET_CARDS_DOWNLOAD_LOW_FILE: "cards/download-low-file",

    GET_CHAIN_CATEGORIES: "chain-categories",
    GET_INTEREST_POINTS: "interest-points",
};
